/** RFC-style email validation: local@domain.tld */
export const isValidEmail = (value: string): boolean =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value ?? '').trim());

export const isEqualString = (
  status1?: string | number | null,
  status2?: string | number | null
): boolean => {
  const str1 = status1 ? String(status1).toLowerCase() : '';
  const str2 = status2 ? String(status2).toLowerCase() : '';
  return !!str2 && !!str1 && str1.includes(str2);
};

export const sliceFiveChar = (str: string): string => (str.length > 5 ? str.slice(0, 5) : str);

export const validSignedUrl = (str: string) => {
  const subStringToCheck = 'https://ibe-dev-attach.s3.amazonaws.com/?AWSAccessKeyId';
  return str?.startsWith(subStringToCheck) ? '' : str;
};

export const removeSpecialCharacters = (str: string) =>
  str ? str.replace(/[^a-zA-Z0-9]/g, '') : '';

export const generateRegexPattern = (patterns: string[], testString?: string): boolean => {
  // Define the mappings
  const mappings: { [key: string]: string } = {
    '*': '[a-zA-Z0-9]',
    '#': '\\d',
    '@': '[a-zA-Z]',
    '-': '\\-',
    '.': '\\.',
    _: '_',
    '(': '\\(',
    ')': '\\)',
  };
  const regexes = patterns.map((pattern) => {
    let regexPattern = '';
    for (let char of pattern) {
      if (mappings[char]) {
        regexPattern += mappings[char];
      } else {
        regexPattern += char;
      }
    }
    return new RegExp(`^${regexPattern}$`);
  });

  if (testString !== undefined) {
    return regexes.some((regex) => regex.test(testString));
  }

  return true;
};
